import React from "react";
import { MODULE_SCHEDULE_TEMPLATES } from "variables/modules";
import EmployeeScheduleTemplate from ".";
import { generateCRUDRoutes } from "utils";
import ViewEmployeeScheduleTemplate from "./view";

const employeeScheduleTemplateRoutes = [
    generateCRUDRoutes({
        mainTitle: "Employee Schedule Templates",
        basePath: "employee-schedule-templates",
        mainComponent: <EmployeeScheduleTemplate />,
        viewComponent: <ViewEmployeeScheduleTemplate/>,
        layout: "/console",	   
        subTitle:"Employee Schedule Templates",
        level:4,
        moduleId: MODULE_SCHEDULE_TEMPLATES,  
    })
]

export default employeeScheduleTemplateRoutes;